import React, { useState } from "react";
import { Loader2, RotateCcw, X } from "lucide-react";
import { toast } from "sonner";
import { api, formatError } from "@/lib/api";

export const ReturnRequestDialog = ({ order, onClose, onRequested }) => {
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (event) => {
    event.preventDefault();
    setBusy(true);
    try {
      const response = await api.post(`/orders/${order.id}/returns`, { reason });
      toast.success("Return request sent for review");
      onRequested(response.data);
      onClose();
    } catch (error) {
      toast.error(formatError(error));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-end justify-center bg-black/35 p-4 sm:items-center"
      role="dialog"
      aria-modal="true"
      aria-labelledby="return-request-title"
      data-testid="return-request-dialog"
    >
      <form className="w-full max-w-lg bg-white p-5 sm:p-6" onSubmit={submit}>
        <div className="flex items-start justify-between gap-4">
          <div>
            <div className="flex items-center gap-2 text-[#2D5A47]">
              <RotateCcw size={18} />
              <h2 id="return-request-title" className="font-serif text-2xl font-semibold">
                Request a return
              </h2>
            </div>
            <p className="mt-2 text-sm text-[#64748B]">
              Tell us why you would like to return this delivered order.
            </p>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="p-1 text-[#64748B] hover:text-[#1E2A24]"
            aria-label="Close return request"
            data-testid="close-return-request-dialog"
          >
            <X size={18} />
          </button>
        </div>
        <label className="mt-5 block text-sm font-semibold text-[#1E2A24]">
          Return reason
          <textarea
            required
            minLength="5"
            maxLength="1000"
            value={reason}
            onChange={(event) => setReason(event.target.value)}
            rows="4"
            placeholder="For example, received the wrong item or it arrived damaged."
            className="mt-2 block w-full border border-[#E2DCD2] px-3 py-2 text-sm"
            data-testid="return-request-reason"
          />
        </label>
        <button
          type="submit"
          disabled={busy || reason.trim().length < 5}
          className={[
            "mt-5 inline-flex w-full items-center justify-center gap-2 bg-[#2D5A47]",
            "px-4 py-3 text-sm font-semibold text-white disabled:cursor-not-allowed",
            "disabled:opacity-50",
          ].join(" ")}
          data-testid="submit-return-request"
        >
          {busy && <Loader2 size={16} className="animate-spin" />}
          {busy ? "Sending request…" : "Send return request"}
        </button>
      </form>
    </div>
  );
};